import { FanViewLanguage } from "./enum/fanViewLanguage";
import { decode } from "html-entities";
import { LocalizedString } from "./localizedString";

export class WinnerCustomInfo {
  message: LocalizedString;
  value: { [key: string]: string } | null;

  constructor(
    message: LocalizedString,
    value: { [key: string]: string } | null,
  ) {
    this.message = Object.fromEntries(
      Object.entries(message).map(([key, value]) => [key, decode(value)]),
    );
    this.value = value;
  }

  getShortMessage(lang: FanViewLanguage): string {
    if (this.value) {
      return Object.entries<string>(this.value)
        .map(
          ([key, value]) =>
            `<span class="font-bold">${key}</span><br/><span class="pl-5 box-decoration-clone whitespace-pre-line">${value}</span>`,
        )
        .join("<br/>");
    } else {
      return "";
    }
  }

  getMessage(lang: FanViewLanguage): string {
    let msg = this.message[lang] || "";
    if (msg && this.value) {
      Object.entries<string>(this.value).forEach(
        ([key, value]) => (msg = msg.replace(`{${key}}`, value)),
      );
    }

    return msg;
  }
}
